import Asset from './Asset'

export interface ICommonAssetDetails {
  asset: Asset
  displayName: string
  spriteLogo: string
}

const commons: Record<Asset, ICommonAssetDetails> = {
  AAVE: { asset: Asset.AAVE, displayName: 'AAVE', spriteLogo: 'ic_token_aave' },
  APE: { asset: Asset.APE, displayName: 'APE', spriteLogo: 'token-ape' },
  ARB: { asset: Asset.ARB, displayName: 'ARB', spriteLogo: 'arbitrum-logo' },
  AUTO: { asset: Asset.AUTO, displayName: 'AUTO', spriteLogo: 'ic_token_auto' },
  BNB: { asset: Asset.BNB, displayName: 'BNB', spriteLogo: 'ic_token_bnb' },
  BPT: { asset: Asset.BPT, displayName: 'BPT', spriteLogo: 'ic_token_bpt' },
  BTCB: { asset: Asset.BTCB, displayName: 'BTCB', spriteLogo: 'ic_token_btc' },
  BUSD: { asset: Asset.BUSD, displayName: 'BUSD', spriteLogo: 'ic_token_busd' },
  BZRX_BNB: { asset: Asset.BZRX_BNB, displayName: 'BZRX/BNB', spriteLogo: 'ic_token_bzrx_bnb' },
  BZRX: { asset: Asset.BZRX, displayName: 'BZRX', spriteLogo: 'ic_token_bzrx' },
  CAKE: { asset: Asset.CAKE, displayName: 'CAKE', spriteLogo: 'ic_token_cake' },
  COMP: { asset: Asset.COMP, displayName: 'COMP', spriteLogo: 'ic_token_comp' },
  CRV: { asset: Asset.CRV, displayName: 'CRV', spriteLogo: 'token-crv' },
  CRV3: { asset: Asset.CRV3, displayName: '3CRV', spriteLogo: 'token-crv' },
  DAI: { asset: Asset.DAI, displayName: 'DAI', spriteLogo: 'ic_token_dai' },
  DOGE: { asset: Asset.DOGE, displayName: 'DOGE', spriteLogo: 'ic_token_doge' },
  ETH: { asset: Asset.ETH, displayName: 'ETH', spriteLogo: 'ic_token_eth' },
  FRAX: { asset: Asset.FRAX, displayName: 'FRAX', spriteLogo: 'token-frax' },
  IAAVE: { asset: Asset.IAAVE, displayName: 'iAAVE', spriteLogo: 'ic_token_iaave' },
  IAPE: { asset: Asset.IAPE, displayName: 'iAPE', spriteLogo: 'token-ape' },
  IARB: { asset: Asset.IARB, displayName: 'iARB', spriteLogo: 'arbitrum-logo' },
  IAUTO: { asset: Asset.IAUTO, displayName: 'iAUTO', spriteLogo: 'ic_token_iauto' },
  IBNB: { asset: Asset.IBNB, displayName: 'iBNB', spriteLogo: 'ic_token_ibnb' },
  IBTCB: { asset: Asset.IBTCB, displayName: 'iBTCB', spriteLogo: 'ic_token_ibtc' },
  IBUSD: { asset: Asset.IBUSD, displayName: 'iBUSD', spriteLogo: 'ic_token_ibusd' },
  IBZRX: { asset: Asset.IBZRX, displayName: 'iBZRX', spriteLogo: 'ic_token_ibzrx' },
  ICAKE: { asset: Asset.ICAKE, displayName: 'iCAKE', spriteLogo: 'ic_token_icake' },
  ICOMP: { asset: Asset.ICOMP, displayName: 'iCOMP', spriteLogo: 'ic_token_comp' },
  IDAI: { asset: Asset.IDAI, displayName: 'iDAI', spriteLogo: 'ic_token_dai' },
  IDOGE: { asset: Asset.IDOGE, displayName: 'iDOGE', spriteLogo: 'ic_token_idoge' },
  IETH: { asset: Asset.IETH, displayName: 'iETH', spriteLogo: 'ic_token_ieth' },
  IFRAX: { asset: Asset.IFRAX, displayName: 'iFRAX', spriteLogo: 'token-frax' },
  IKNC: { asset: Asset.IKNC, displayName: 'iKNC', spriteLogo: 'ic_token_knc' },
  IKNCL: { asset: Asset.IKNCL, displayName: 'iKNCL', spriteLogo: 'ic_token_kncl' },
  ILINK: { asset: Asset.ILINK, displayName: 'iLINK', spriteLogo: 'ic_token_ilink' },
  ILRC: { asset: Asset.ILRC, displayName: 'iLRC', spriteLogo: 'ic_token_lrc' },
  IMATIC: { asset: Asset.IMATIC, displayName: 'iMATIC', spriteLogo: 'ic_token_imatic' },
  IMIM: { asset: Asset.IMIM, displayName: 'iMIM', spriteLogo: 'token-mim' },
  IMKR: { asset: Asset.IMKR, displayName: 'iMKR', spriteLogo: 'ic_token_mkr' },
  IOOKI: { asset: Asset.IOOKI, displayName: 'iOOKI', spriteLogo: 'token-iooki' },
  IOP: { asset: Asset.IOP, displayName: 'iOP', spriteLogo: 'chain-optimism' },
  ISPELL: { asset: Asset.ISPELL, displayName: 'iSPELL', spriteLogo: 'token-spell' },
  IUNI: { asset: Asset.IUNI, displayName: 'iUNI', spriteLogo: 'ic_token_uni' },
  IUSDC: { asset: Asset.IUSDC, displayName: 'iUSDC', spriteLogo: 'ic_token_usdc' },
  IUSDT: { asset: Asset.IUSDT, displayName: 'iUSDT', spriteLogo: 'ic_token_iusdt' },
  IWBTC: { asset: Asset.IWBTC, displayName: 'iWBTC', spriteLogo: 'ic_token_wbtc' },
  IWETH: { asset: Asset.IWETH, displayName: 'iWETH', spriteLogo: 'ic_token_ieth' },
  IYFI: { asset: Asset.IYFI, displayName: 'iYFI', spriteLogo: 'ic_token_yfi' },
  KNC: { asset: Asset.KNC, displayName: 'KNC', spriteLogo: 'ic_token_knc' },
  KNCL: { asset: Asset.KNCL, displayName: 'KNCL', spriteLogo: 'ic_token_kncl' },
  LINK: { asset: Asset.LINK, displayName: 'LINK', spriteLogo: 'ic_token_link' },
  LRC: { asset: Asset.LRC, displayName: 'LRC', spriteLogo: 'ic_token_lrc' },
  MATIC: { asset: Asset.MATIC, displayName: 'MATIC', spriteLogo: 'ic_token_matic' },
  MIM: { asset: Asset.MIM, displayName: 'MIM', spriteLogo: 'token-mim' },
  MKR: { asset: Asset.MKR, displayName: 'MKR', spriteLogo: 'ic_token_mkr' },
  OOKI: { asset: Asset.OOKI, displayName: 'OOKI', spriteLogo: 'token-ooki' },
  OP: { asset: Asset.OP, displayName: 'OP', spriteLogo: 'chain-optimism' },
  P125: { asset: Asset.P125, displayName: 'P125', spriteLogo: 'token-p125' },
  SLP_OOKI_ETH: { asset: Asset.SLP_OOKI_ETH, displayName: 'OOKI/ETH SLP', spriteLogo: 'token-slp' },
  SLP: { asset: Asset.SLP, displayName: 'SLP', spriteLogo: 'token-slp' },
  SPELL: { asset: Asset.SPELL, displayName: 'SPELL', spriteLogo: 'token-spell' },
  STMATIC: { asset: Asset.STMATIC, displayName: 'stMATIC', spriteLogo: 'token-stmatic' },
  SUSHI: { asset: Asset.SUSHI, displayName: 'SUSHI', spriteLogo: 'token-sushi' },
  UNI: { asset: Asset.UNI, displayName: 'UNI', spriteLogo: 'ic_token_uni' },
  USDC: { asset: Asset.USDC, displayName: 'USDC', spriteLogo: 'ic_token_usdc' },
  USDT: { asset: Asset.USDT, displayName: 'USDT', spriteLogo: 'ic_token_usdt' },
  vBZRX: { asset: Asset.vBZRX, displayName: 'vBZRX', spriteLogo: 'token-vbzrx' },
  vOOKI: { asset: Asset.vOOKI, displayName: 'vOOKI', spriteLogo: 'token-ooki' },
  WBNB: { asset: Asset.WBNB, displayName: 'WBNB', spriteLogo: 'ic_token_bnb' },
  WBTC: { asset: Asset.WBTC, displayName: 'WBTC', spriteLogo: 'ic_token_wbtc' },
  WETH: { asset: Asset.WETH, displayName: 'WETH', spriteLogo: 'ic_token_eth' },
  WMATIC: { asset: Asset.WMATIC, displayName: 'WMATIC', spriteLogo: 'ic_token_matic' },
  WSTETH: { asset: Asset.WSTETH, displayName: 'wstETH', spriteLogo: 'token-wsteth' },
  YFI: { asset: Asset.YFI, displayName: 'YFI', spriteLogo: 'ic_token_yfi' },
  // TODO: Not sure what to do about this one.
  UNKNOWN: { asset: Asset.UNKNOWN, displayName: '', spriteLogo: '' },
}

export default commons
